import { render, staticRenderFns } from "./AdShopLink.vue?vue&type=template&id=bd5a3bf2&scoped=true&"
import script from "./AdShopLink.vue?vue&type=script&lang=js&"
export * from "./AdShopLink.vue?vue&type=script&lang=js&"
import style0 from "./AdShopLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdShopLink.vue?vue&type=style&index=1&id=bd5a3bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5a3bf2",
  null
  
)

export default component.exports